const getters = {
  unreadNotificationsCount: state => {
    return state.notifications.filter(n => n.marked_as_read === false).length
  }
}

export default getters
